const UPDATE = (state, data) => {
  for (let key in data) {
    state.accessCode[key] = data[key]
  }
}

const REVOKE = (state) => {
  state.accessCode = {}
}

const SET_ACCESS_CODE = (state, accessCode) => {
  state.accessCode = accessCode
}

export default {
  UPDATE,
  REVOKE,
  SET_ACCESS_CODE
}
